{
  "withSubscribe": {
    "emptyCIS": "empty CIS list",
    "connecting": "connecting..."
  },
  "TestWidget": {
    "title": "Test widget",
    "description": "Test widget"
  },
  "AlertWidget": {
    "title": "Alert list",
    "description": "List of recent alarms",
    "columns": {
      "name": "Name",
      "severity": "Severity",
      "alert": "Alert",
      "start": "Start",
      "end": "End"
    }
  },
  "TitleProps": {
    "title": "Title props",
    "ellipsis": "Ellipsis",
    "size": "Text size"
  },
  "Chord": {
    "title": "Chord",
    "description": "Chord"
  },
  "Sankey": {
    "title": "Sankey",
    "description": "Sankey"
  },
  "SovJsonWidget": {
    "title": "Show SOV",
    "description": "Show SOV"
  },
  "PieCharts": {
    "title": "Pie сhart",
    "description": "Aggregate data to pie chart"
  },
  "ChartWidget": {
    "title": "Chart",
    "description": "Draw chart from data"
  },
  "AreaWidget": {
    "title": "Area",
    "description": "Draw area chart from data"
  },
  "TableWidget": {
    "title": "Table",
    "description": "Table"
  },
  "TabsWidget": {
    "title": "Tabs",
    "description": "Tabs widget"
  },
  "InfoWidget": {
    "title": "Hi",
    "description": "Hi status widget"
  },
  "ValueWidget": {
    "title": "Value status",
    "description": "Metrics value with threshold"
  },
  "AttributesWidget": {
    "title": "Attributes",
    "description": "Attributes widget"
  },
  "CITreeWidget": {
    "title": "CI tree",
    "description": "Tree of CI"
  },
  "GaugeWidget": {
    "title": "Gauge",
    "description": "Gauge"
  },
  "Cytoscape": {
    "title": "Graph",
    "description": "Displaying TQL as a graph"
  },
  "NewMetric": {
    "title": "Line graph",
    "description": "Make two axes on one plot",
    "DataParser": {
      "Title": "Data parser",
      "metricQuery": "Запрос {{index}}",
      "cardTitle": {
        "0": "Value axis",
        "1": "Additional value axis"
      },
      "query": "Query",
      "name": "Metric"
    },
    "TimeFormat": {
      "Title": "Time format"
    }
  },
  "NewWidget": {},
  "config": {
    "TitleOption": {
      "title": "Title"
    },
    "ViewOption": {
      "title": "Set Display Method CI : ",
      "table": "Table",
      "tabs": "Tabs",
      "grid": "Grid"
    }
  },
  "options": {
    "TitleOption": "Title",
    "FilterOption": "Filter",
    "ViewOption": "Display method",
    "TabLabelOption": "Tabs title",
    "GridLabel": "Grid title",
    "SchemaConstructor": "Tree constructor",
    "AlertOptions": "Настройки",
    "CITDashboard": {
      "title": "Linking Dashboard to CIT",
      "header": "Which Dashboard should be drawn when you click on CIT :",
      "single": "Single",
      "group": "Group"
    },
    "ChartRewrite": {
      "title": "rewrite axes"
    },
    "ChartAction": {
      "title": "Настройка событий",
      "add": "Добавить событие",
      "element": "Элемент",
      "event": "Событие",
      "action": "Действие"
    },
    "ChartParse": {
      "title": "Data parse",
      "configTitle": "Name source",
      "group": "Group",
      "groupKey": "Group key",
      "groupView": "Group view",
      "tabs": "Tabs",
      "grid": "Grid",
      "yes": "Yes",
      "no": "No"
    },
    "AreaConfig": {
      "title": "Настройка области"
    },
    "StatusOverTime": {
      "Flags": {
        "title": "Display settings",
        "main": "Статус CI",
        "second": "Индикатор здоровья"
      },
      "Delimiters": {
        "title": "Delimiters"
      },
      "TimeSettings": {
        "title": "Time settings"
      }
    },
    "Table": {
      "Current": {
        "title": "Current CIT"
      },
      "General": {
        "title": "General settings"
      },
      "Hidden": {
        "title": "Hidden column"
      },
      "Rewrite": {
        "title": "Rewrite column"
      }
    },
    "Gauge": {
      "Main": {
        "main": "Main settings",
        "thresholds": "Thresholds",
        "from": "From",
        "to": "To",
        "Title": "Settings",
        "base": "Base",
        "percent": "Percent",
        "absolute": "Absolute"
      }
    },
    "AlertWidget": {
      "showHistory": "Show history",
      "defaultSort": "Default sort"
    }
  },
  "nodeWidth": {
    "title": "Sizing settings",
    "nodeWidthRatio": "Node width",
    "nodePaddingRatio": "Node padding",
    "small": "Small",
    "medium": "Medium",
    "large": "Large"
  },
  "isInterval": {
    "title": "Interval setting",
    "label": "Last value"
  },
  "chordMapper": {
    "title": "Mapper",
    "source": "Source",
    "target": "Target",
    "noSource": "Set up Mapper -> Source | Target"
  },
  "chordRewrite": {
    "title": "Rewrite",
    "namePlaceholder": "Source | Target",
    "rewritePlaceholder": "rewrite value"
  },
  "chartEvents": {
    "click": "click",
    "mousedown": "mousedown",
    "mouseup": "mouseup",
    "dblclick": "dblclick",
    "mouseenter": "mouseenter",
    "mouseout": "mouseout",
    "mouseover": "mouseover",
    "mousemove": "mousemove",
    "mouseleave": "mouseleave",
    "contextmenu": "contextmenu",
    "touchstart": "touchstart",
    "touchmove": "touchmove",
    "touchend": "touchend"
  },
  "chartElements": {
    "element": "element",
    "legend-item": "legend-item",
    "axis-label": "axis-label",
    "mask": "mask",
    "plot": "plot",
    "legend-item-name": "legend-item-name",
    "reset-button": "reset-button"
  },
  "chartActions": {
    "openDashboard": "Open dashboard"
  },
  "StatusOverTimeWidget": {
    "title": "History Hi",
    "description": "History Hi",
    "nullHiHistory": "No data on selected CI",
    "nullParsedData": "Processing"
  },
  "actions": {
    "openDashboard": "Dashboard ID"
  },
  "cyLayout": {
    "title": "Layout setting",
    "layout": "layout"
  }
}